import { render, staticRenderFns } from "./PatientsFormGuardiansPopup.vue?vue&type=template&id=576b0a58&"
import script from "./PatientsFormGuardiansPopup.vue?vue&type=script&lang=js&"
export * from "./PatientsFormGuardiansPopup.vue?vue&type=script&lang=js&"
import style0 from "./PatientsFormGuardiansPopup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports